export const siteConfig = {
  name: "Luís Peixoto",
  url: "https://peixotomdb.com",
  email: "peixotomdb@gmail.com",
  social: {
    github: "https://github.com/peixotomdb",
    linkedin: "https://linkedin.com/in/peixotomdb",
    docker: "https://hub.docker.com/r/peixotomdb/deadletter",
  },
}
